import { getCurrentDevicesInfo, getNormalizedDevices } from '../selectors';
import { getUpdatedCurrentDevices } from '../helpers';
import { CURRENT_DEVICES_STORAGE_KEY } from '../constants';
export const restoreCurrentDevices = () => (dispatch) => {
    const current = JSON.parse(localStorage.getItem(CURRENT_DEVICES_STORAGE_KEY)) || {};
    dispatch({ type: 'DEVICES/SET_CURRENT_DEVICES', payload: current });
};
export const updateCurrentDevices = (currentDevices) => (dispatch, getState) => {
    const hasAccess = Object.entries(currentDevices).some(([, v]) => Boolean(v));
    if (hasAccess) {
        const savedDevices = getCurrentDevicesInfo(getState());
        const updatedCurrentDevices = { ...savedDevices, ...currentDevices };
        localStorage.setItem(CURRENT_DEVICES_STORAGE_KEY, JSON.stringify(updatedCurrentDevices));
        dispatch({
            type: 'DEVICES/SET_CURRENT_DEVICES',
            payload: updatedCurrentDevices,
        });
    }
};
export const changeAudioDevice = (microphoneId) => (dispatch) => dispatch(updateCurrentDevices({ microphoneId }));
export const changeVideoDevice = (cameraId) => (dispatch) => dispatch(updateCurrentDevices({ cameraId }));
export const changeOutputDevice = (speakerId) => (dispatch) => dispatch(updateCurrentDevices({ speakerId }));
export const clearCurrentDevices = () => (dispatch) => {
    localStorage.removeItem(CURRENT_DEVICES_STORAGE_KEY);
    dispatch({
        type: 'DEVICES/SET_CURRENT_DEVICES',
        payload: {},
    });
};
export const checkCurrentDevices = () => (dispatch, getState) => {
    const devices = getNormalizedDevices(getState());
    const currentDevices = getCurrentDevicesInfo(getState());
    dispatch(updateCurrentDevices(getUpdatedCurrentDevices(devices, currentDevices)));
};
